import { ErrorView, StaticContextRoute } from '@atlassian/mpac-ui';
import React from 'react';

import Meta from '../Meta';

import type { RouterHistory } from 'react-router';

export type ErrorPageProps = {
  homeLink: string;
  heading: string;
  primaryMessage: string;
  history?: RouterHistory;
  image: string;
  statusCode: number;
  title: string;
};

const ErrorPage = (props: ErrorPageProps) => {
  const { title, statusCode, ...errorViewProps } = props;
  return (
    <StaticContextRoute
      statusCode={statusCode}
      render={() => (
        <>
          {/* @ts-expect-error [MC-2850] - TS2739 - Type '{ title: string; }' is missing the following properties from type 'MetaTypes': canonicalUrl, description, image, openGraphImage, twitterImage */}
          <Meta title={title} />
          <ErrorView statusCode={statusCode} {...errorViewProps} />
        </>
      )}
    />
  );
};

export default ErrorPage;
